import { defineComponent } from 'vue';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'background-service-dsgn',
    mixins: [BaseComponentMixin],
    data: function () {
        return {
            childMenus: null,
        };
    },
    methods: {
        jumpToMenu(e, menu) {
            this.childMenus = null;
            this.Root.ExternalNavigate('Apps/UI/MenuItem/' + menu._id);

            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        controlData: {}
    },
    render() {
        let icontitle = (
            <span style={{ fontSize: 'x-large' }}>
                {this.designmodel?.MenuItemData?.Title}
            </span>
        );

        if (!this.controlData || !Array.isArray(this.controlData.Controls))
            return null;

        let items = [];
        for (let i = 0; i < this.controlData.Controls.length; i++)
        {
            const control = this.controlData.Controls[i];
            let DynamicControl = utils.getDesignerComponent(control, null);

            items.push(
                <DynamicControl
                    key={control.$objectId || `${control.ControlType || 'unknown'}_${i}`}
                    type={control.ControlType}
                    name={control.ControlData ? control.ControlData.Name : null}
                    root={this.root}
                    designmodel={control}
                    parentType="VerticalStack"
                    controlData={control.ControlData}
                    controlURL={control.ControlURL}>
                </DynamicControl>
            );
        }
        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ ...utils.getSize(this.controlData.SizeOptions) }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected-clickthrough': this.selected$ }}></div>
                {icontitle}
                {this.name}<br />
                {items}
            </div>
        );
    }
});